module.exports = __webpack_public_path__ + "Ishakmohmmedkhan-90494d01.webp";